const getDays = () => Array.apply(null, { length: 31 }).map((item, index) => ({ value: index + 1, label: index + 1 }));

export const selectDay = getDays();

export const selectMonth = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

export const entryType = [
  { value: 'Company', label: 'Company' },
  { value: 'Partnership', label: 'Partnership' },
  { value: 'Sole Trader', label: 'Sole Trader' },
  { value: 'Unit Trust', label: 'Unit Trust' },
  { value: 'Discretionary Trust', label: 'Discretionary Trust' },
];

export const region = [{ value: 'AU', label: 'Australia' }, { value: 'NZ', label: 'New Zealand' }];

export const banks = [
  { value: 1, label: 'ANZ' },
  { value: 18, label: 'Bank of Melbourne' },
  { value: 29, label: 'Bank of Qld' },
  { value: 21, label: 'Bank of SA' },
  { value: 4, label: 'CBA' },
  { value: 41, label: 'Heritage' },
  { value: 7, label: 'NAB' },
  { value: 2, label: 'St George' },
  { value: 17, label: 'Westpac' },
];

export const popularBankList = [
  { bankId: 1 }, //ANZ
  { bankId: 4 }, //Commbank
  { bankId: 7 }, //NAB
];

export const secondPopularBankList = [
  { bankId: 17 }, //Westpac
  { bankId: 2 }, //St.George
  { bankId: 34 }, //Bendigo
];

export const nzPopularBankList = [
  { bankId: 11 }, //KiwiBank
  { bankId: 16 }, //ASB
  { bankId: 28 }, //ANZ (NZ)
];

export const nzSecondPopularBankList = [
  { bankId: 40 }, //BNZ
  { bankId: 33 }, //TSB
  { bankId: 26 }, //Westpac (NZ)
];

export const nzBanks = [
  { value: 16, label: 'ASB' },
  { value: 28, label: 'ANZ' },
  { value: 40, label: 'BNZ' },
  { value: 11, label: 'Kiwibank' },
  { value: 11, label: 'Kiwibank - Card' },
  { value: 14, label: 'NBS' },
  { value: 33, label: 'TSB' },
  { value: 26, label: 'Westpac' },
];

export const rahVersion = [{ value: 'CountryVersion', label: 'CountryVersion' }, { value: '2015.R2.AU', label: '2015.R2.AU' }];

export const shareEmailTemp = {
  message: `Dear [FIRST_NAME], 

Your Accountant has provided you with access to the BankFeed Management window.
This would usually occur where they require you to log in to finalise the setup of your Banking details in order for them to process your Accounts. 

If you are unsure why you have received this email, please contact your Accountant.`,
};

export const filterByOptions = ['All', 'Uncoded', 'Coded', 'Unmatched', 'Matched', 'Unapplied Rules'];



// WEBPACK FOOTER //
// ./src/components/Common/SelectLists.js